import { render, staticRenderFns } from "./DevWrapper.vue?vue&type=template&id=409a46cd&scoped=true&"
import script from "./DevWrapper.vue?vue&type=script&lang=js&"
export * from "./DevWrapper.vue?vue&type=script&lang=js&"
import style0 from "./DevWrapper.vue?vue&type=style&index=0&id=409a46cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "409a46cd",
  null
  
)

export default component.exports